import React, { useEffect } from 'react'
import { ThemeProvider } from '@mui/material'
import type { AppProps } from 'next/app'
import { useContext } from 'react'

import Toast from '../shared-web/components/Toast/Toast'
import RootStore from '../src/stores/RootStore'
import { theme } from '../theme'
import { I18nContext } from '../shared-lib/i18n/i18n'
import packageJSON from '../package.json'
import 'animate.css'
import { observer } from 'mobx-react-lite'
import { getBrowserTimezone } from '../shared-lib/utils'
import analytics from '../src/stores/analytics'

const MyApp = observer(({ Component, pageProps }: AppProps) => {
  const store = useContext(RootStore)
  const { uiStore, ready } = store

  useEffect(() => {
    analytics.init()

    const loadStore = async () => {
      const communicationLoaded = await store.loadCommunication({
        apiDefault: process.env.API_DEFAULT,
        platform: process.env.PLATFORM,
        timezone: getBrowserTimezone(),
        env: process.env.SS_ENV,
        appVersion: packageJSON.version,
        override: process.env.API_OVERRIDE_URL,
      })

      if (!communicationLoaded) {
        store.uiStore.showToast(
          'Please check you are connected to wifi or mobile internet and try again.',
          'error',
        )

        return
      }

      await store.loadStore()
    }

    loadStore()
  }, [])

  return <>
    <ThemeProvider theme={theme}>
      <I18nContext.Provider value={store.i18n}>
        {ready &&
          <>
            <Component {...pageProps} store={store} />
            <Toast toastData={uiStore.toastData} hideToast={uiStore.hideToast} />
          </>
        }
      </I18nContext.Provider>
    </ThemeProvider>
  </>
})

export default MyApp
